<script>
import DefaultMunicipalities from '@/assets/js/default-municipalities'
import Surrounding from '@/mixins/Surrounding'
import Utilities from '@/mixins/Utilities'
import DbService from '@/services/DbService'

export default {
  mixins: [Surrounding, Utilities],
  methods: {
    geoLocation () {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 8000 })
      })
    },
    getSiteData (city = null, bgSync = null) {
      if (!bgSync) {
        this.$store.commit('setIsLoading', true)
      }
      this.$store.commit('setMunicipalityList', this.sortByString(DefaultMunicipalities, 'name'))

      if (city === null) {
        this.geoLocation().then((res) => {
          this.$store.commit('setLoaderText', 'Locatie zoeken..')
          this.$cookies.set('locationDenied', false, -1)
          this.$cookies.remove('locationPopupInActive')
          this.setPosition(res.coords.latitude, res.coords.longitude)
        }).catch((err) => {
          if (err.code === 1) {
            this.$store.commit('setLocationDenied', true)
            this.$cookies.set('locationDenied', true, -1)
          }
          this.$store.commit('setLoaderText', 'Laden..')

          this.$store.commit('setEventLoader', true)
          this.$store.commit('setNewsLoader', true)

          if (window.indexedDB) {
            this.setWithCachedData()
          } else {
            this.openDialog()
          }
        })
      } else {
        this.updateSurrounding(city, bgSync)
      }
    },
    openDialog () {
      this.$store.commit('setIsLoading', false)

      this.$store.commit('setMunicipalitySelect', true)
    },
    setWithCachedData () {
      // Get last visited surrounding
      DbService.readAllData('current-surrounding').then((data) => {
        if (data.length) {
          // Set surrounding with founded data
          this.$store.commit('setSurrounding', data[0])
          this.$store.state.surrounding.municipalityId = data[0].municipalityId

          // Set menu with dynamic content
          // this.setMenu(data[0].name)

          // Set municipality data based on current surrounding
          this.fetchMunicipalityData(data[0].name).then((surrounding) => {
            this.$store.commit('setMunicipality', {
              inhabitants: surrounding['inwoneraantal(CBS/1-1-2019)'],
              surface: surrounding['totale oppervlakte(km²) (CBS/2018)']
            })

            this.setWeatherData(data[0].gps.lat, data[0].gps.lng)
          }).catch((err) => {
            /* eslint-disable no-console */
            console.warn(err + ' - indexedDB')
            this.setWeatherData(data[0].gps.lat, data[0].gps.lng)
          })

          // Set related data
          this.setRelatedData(data[0].municipalityId, data[0].id)

          this.$store.commit('setCurrentPosition', {
            disabled: false,
            error: null,
            lat: data[0].gps.lat,
            lng: data[0].gps.lng
          })

          return
        }

        // Open dialog if no data is found
        this.openDialog()
      })
    },
    setPosition (lat, lng) {
      this.$store.commit('setCurrentPosition', {
        disabled: false,
        error: null,
        lat: lat,
        lng: lng
      })

      // Get surrounding based on current position
      this.getSurrounding(lat, lng)
    }
  }
}
</script>
